export default __webpack_public_path__ + "static/media/TokenSymbols.3ce288c4.ttf";